import React, { Dispatch, ReactNode, SetStateAction } from 'react';

import * as S from './styles';
import { Modal } from '@mui/material';

interface Props {
  isOpen: boolean;
  children: ReactNode;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  handleOnClose?: () => void;
  isFloat?: boolean;
  zIndex?: number;
  disableEsc?: boolean;
  ableBackdropClick?: boolean;
  noPadding?: boolean;
}

export default function BasicModal({
  isOpen,
  setIsOpen,
  handleOnClose,
  children,
  isFloat,
  zIndex,
  disableEsc,
  ableBackdropClick = false,
  noPadding,
}: Props) {
  return (
    <Modal
      open={!!isOpen}
      disableEscapeKeyDown={disableEsc}
      onClose={(_, reason) => {
        if (reason && reason === 'backdropClick' && !ableBackdropClick) {
          return;
        }
        handleOnClose && handleOnClose();
        setIsOpen(false);
      }}
      aria-labelledby="modal-basic"
      aria-describedby="modal-basic-description"
      sx={{
        backgroundColor: 'rgba(0, 0, 0, .6)',
        overflow: 'auto',
        zIndex: zIndex ? zIndex : 100,
        width: '100vw',
        height: '100vh',
        position: 'fixed',
      }}
    >
      <S.BoxStyle
        sx={{
          p: 4,
          ...(isFloat && {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }),
          '&.MuiBox-root': {
            padding: '0',
          },
        }}
      >
        <S.PaperStyled noPadding={noPadding}>{children}</S.PaperStyled>
      </S.BoxStyle>
    </Modal>
  );
}
